// Keep only the opaque server reference; never collect request/response payloads.
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const installedClients = new WeakSet();

export const validRequestId = value => typeof value === 'string' && UUID.test(value) ? value : null;

export const getRequestId = error => {
  try {
    const headers = error?.response?.headers;
    return validRequestId(error?.requestId)
      || validRequestId(typeof headers?.get === 'function' ? headers.get('x-request-id') : null)
      || validRequestId(headers?.['x-request-id'])
      || validRequestId(headers?.['X-Request-ID'])
      || validRequestId(error?.response?.data?.requestId);
  } catch {
    return null;
  }
};

export const installRequestDiagnostics = client => {
  if (installedClients.has(client)) return;
  installedClients.add(client);
  client.interceptors.response.use(response => response, error => {
    try {
      if (error?.code !== 'ERR_CANCELED' && error?.__CANCEL__ !== true) {
        const requestId = getRequestId(error);
        const status = error?.response?.status;
        if (requestId) error.requestId = requestId;
        console.error('API request failed', {
          requestId,
          status: Number.isInteger(status) && status >= 100 && status <= 599 ? status : null,
        });
      }
    } catch {
      // Diagnostics must not replace the original request failure.
    }
    return Promise.reject(error);
  });
};
